.loading {
  margin: 0 auto;
  text-align: center;
}
